import React, {HTMLAttributes} from "react";
import classNames from "classnames";

interface DefinitionListItemProps{
  term: string
  children: React.ReactNode
}

export function SVVDefinitionListItem({children, term}: DefinitionListItemProps) {
  return <div className="svv-dl-container">
    <dt className="svv-dt">{term}</dt>
    <dd className="svv-dd">{children}</dd>
  </div>
}
interface DefinitionListProps {
  children: React.ReactElement<DefinitionListItemProps> | React.ReactElement<DefinitionListItemProps>[]
  heading?: string
  headingLevel?: AS
  column?: boolean
  className?: string
}

type AS = Extract<keyof JSX.IntrinsicElements, "h1" |"h2" | "h3" | "h4" | "h5" | "h6">

interface HTMLTagProps extends HTMLAttributes<HTMLOrSVGElement> {
  as: AS;
}

const HeadingElement = ({ as: As, ...rest }: HTMLTagProps) => <As {...rest}/>

export function SVVDefinitionList({children, heading, headingLevel = "h2", column, className}: DefinitionListProps) {
  const renderList = () => (
    <dl className={classNames(`svv-definition-list ${column ? 'svv-definition-list--column' : ''}`, className)}>
      {children}
    </dl>
  )

  if (heading) {
    return (
      <>
        <HeadingElement
          as={headingLevel || "h2"}
          className={`svv-definition-list__heading svv-${(headingLevel === "h5" || headingLevel === "h6") ? "h4" : headingLevel}`}
        >
          {heading}
        </HeadingElement>
        {renderList()}
      </>
    )
  }
  return renderList()
}
